module.exports = __webpack_public_path__ + "static/media/JUST.176629bb.png";